import { useUserInfoStore } from '@/stores/UserInfoStore.ts';
import { apiService } from '@/services/ApiService.ts';
import type { SubscriptionTier } from '@/types/SubscriptionTier.ts';
import { logger } from '@/lib/logger.ts';

export const retrieveUserInfoAction = async () => {
    const userInfoStore = useUserInfoStore();
    userInfoStore.userInfoLoading = true;

    let apiResponse;
    try {
        apiResponse = await apiService.getApi().userInfoV1();
    } catch (error) {
        logger.error('Failed to fetch user data:', error);

        return;
    }

    userInfoStore.username = apiResponse.username;
    userInfoStore.creditsRemaining = apiResponse.creditsRemaining;
    userInfoStore.subscriptionTier = apiResponse.subscriptionTier as SubscriptionTier;

    userInfoStore.userInfoLoading = false;
};
